/* ============================================================================
   PREMIUM PRODUCT TEMPLATE — InnovaZone
   Gallery thumbs, reveal animations, sticky CTA, recommended carousel,
   Shopify product recommendations fetch.
============================================================================ */

(function () {
  'use strict';

  // V42.2 — version visible para saber qué build está live (footer chip via layout)
  window.__INNOVAZONE_VERSION = 'V42.2';

  // V42.3 — Debug SOLO en consola (sin overlay rojo visible al cliente). Si el
  // worker falla, el flujo cae automáticamente al checkout estándar (V36). El
  // dev puede inspeccionar window.__v41Debug en la consola.
  window.__showV41Debug = function (result) {
    try { window.__v41Debug = result; console.error('[premium-form] V41 worker response', result); } catch (_) {}
  };

  const root = document.querySelector('.prem');
  if (!root) return;

  /* ------------------------------------------------------------------------
     0a. COUNTDOWN TIMER — daily reset to midnight CST
  ------------------------------------------------------------------------ */
  (function () {
    const cd = document.querySelector('[data-prem-countdown]');
    if (!cd) return;
    const h = cd.querySelector('[data-countdown-h]');
    const m = cd.querySelector('[data-countdown-m]');
    const s = cd.querySelector('[data-countdown-s]');
    if (!h || !m || !s) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      let diff = (end - now) / 1000;
      if (diff < 0) diff = 0;
      const hh = Math.floor(diff / 3600);
      const mm = Math.floor((diff % 3600) / 60);
      const ss = Math.floor(diff % 60);
      h.textContent = pad(hh);
      m.textContent = pad(mm);
      s.textContent = pad(ss);
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ------------------------------------------------------------------------
     0b. ACTIVITY TICKER — rotating value-prop notifications (honest, generic)
  ------------------------------------------------------------------------ */
  (function () {
    const ticker = document.getElementById('prem-ticker');
    if (!ticker) return;
    const title = ticker.querySelector('[data-ticker-title]');
    const sub = ticker.querySelector('[data-ticker-sub]');
    const closeBtn = ticker.querySelector('[data-ticker-close]');
    if (!title || !sub) return;

    const messages = [
      { title: 'Envío GRATIS a toda Costa Rica',           sub: 'Mensajería normal · 1-2 días hábiles' },
      { title: 'Pagás contra entrega',                      sub: 'Revisás el producto antes de pagar' },
      { title: 'Más de 10.000 ticos confiaron',             sub: 'Reseñas verificadas · garantía 1 año Samsung' },
      { title: 'Hasta 12 cuotas tasa 0% con BAC/Credix',    sub: 'Aprobación en minutos · sin papeleos' },
      { title: 'Soporte WhatsApp directo',                  sub: 'Asesor te ayuda paso a paso · 6257-8178' },
      { title: 'Mensajero privado 24h en GAM',              sub: 'O encomienda mismo día fuera del GAM' }
    ];

    let idx = 0;
    let dismissed = false;

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        ticker.classList.remove('is-visible');
        setTimeout(function () { ticker.hidden = true; }, 400);
      });
    }

    function show(message) {
      if (dismissed) return;
      title.textContent = message.title;
      sub.textContent = message.sub;
      ticker.hidden = false;
      // double rAF so transition fires after display change
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ticker.classList.add('is-visible');
        });
      });
    }

    function hide() {
      ticker.classList.remove('is-visible');
    }

    // Show first message after 6s, then rotate every 8s (5s visible + 3s hidden between)
    setTimeout(function () {
      show(messages[idx]);
      setInterval(function () {
        if (dismissed) return;
        hide();
        setTimeout(function () {
          if (dismissed) return;
          idx = (idx + 1) % messages.length;
          show(messages[idx]);
        }, 600);
      }, 8000);
    }, 6000);
  })();

  /* ------------------------------------------------------------------------
     0c. EXIT-INTENT POPUP — mouseleave + scroll-up pattern (mobile)
  ------------------------------------------------------------------------ */
  (function () {
    const modal = document.getElementById('prem-exitmodal');
    if (!modal) return;

    const STORAGE_KEY = 'prem_exit_intent_shown';
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    function showModal() {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
      sessionStorage.setItem(STORAGE_KEY, '1');
      modal.hidden = false;
      // lock background scroll
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    // Desktop: mouseleave at top of viewport
    let armedDesktop = false;
    setTimeout(function () { armedDesktop = true; }, 8000); // arm after 8s

    document.addEventListener('mouseout', function (e) {
      if (!armedDesktop) return;
      if (e.relatedTarget !== null) return;
      if (e.clientY > 5) return;
      showModal();
    });

    // Mobile: detect "back" gesture / fast scroll up after substantial engagement
    let scrolledDown = false;
    let lastScrollY = window.scrollY;
    let armedMobile = false;
    setTimeout(function () { armedMobile = true; }, 12000); // arm after 12s

    window.addEventListener('scroll', function () {
      const y = window.scrollY;
      if (y > 600) scrolledDown = true;
      if (armedMobile && scrolledDown && y < 200 && y < lastScrollY - 200) {
        showModal();
      }
      lastScrollY = y;
    }, { passive: true });

    // Close handlers
    modal.querySelectorAll('[data-exitmodal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    // Accept handler — captures email, picks SINPE payment + applies bump pct + scrolls to form
    const acceptBtn = modal.querySelector('[data-exitmodal-accept]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        const bumpPct = parseInt(acceptBtn.dataset.bumpPct, 10) || 20;
        const emailInput = modal.querySelector('[data-exitmodal-email]');
        const email = emailInput ? emailInput.value.trim() : '';

        // Save email locally so it pre-fills the form if customer comes back
        if (email && /\S+@\S+\.\S+/.test(email)) {
          try { localStorage.setItem('innovazone_lead_email', email); } catch (e) {}
        }

        const form = document.getElementById('prem-purchase-form');
        if (form) {
          // Pre-fill email field in form if captured
          if (email) {
            const formEmail = form.querySelector('input[name="email"]');
            if (formEmail && !formEmail.value) formEmail.value = email;
          }
          const sinpe = form.querySelector('input[name="payment"][value="sinpe"]');
          if (sinpe) {
            sinpe.checked = true;
            sinpe.setAttribute('data-discount-pct', String(bumpPct));
            sinpe.dispatchEvent(new Event('change', { bubbles: true }));
          }
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        closeModal();
      });
    }

    // Pre-fill email if we saved it from a previous exit attempt
    try {
      const savedEmail = localStorage.getItem('innovazone_lead_email');
      if (savedEmail) {
        const emailInput = modal.querySelector('[data-exitmodal-email]');
        if (emailInput) emailInput.value = savedEmail;
        // Also pre-fill main form
        const formEmail = document.querySelector('#prem-purchase-form input[name="email"]');
        if (formEmail && !formEmail.value) formEmail.value = savedEmail;
      }
    } catch (e) {}

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();

  /* ------------------------------------------------------------------------
     0c.5. TOAST notifications
  ------------------------------------------------------------------------ */
  const toastEl = document.getElementById('prem-toast');
  let toastTimer = null;
  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toastEl.classList.add('is-visible');
      });
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      setTimeout(function () { toastEl.hidden = true; }, 400);
    }, 2400);
  }

  /* ------------------------------------------------------------------------
     0c.6. WISHLIST — localStorage-based
  ------------------------------------------------------------------------ */
  (function () {
    const STORAGE_KEY = 'innovazone_wishlist';
    const MAX = 50;
    const btn = document.querySelector('[data-wishlist]');
    if (!btn) return;

    function readList() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function writeList(arr) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
    }

    const handle = btn.getAttribute('data-handle') || '';
    const refresh = function () {
      const saved = readList().some(function (p) { return p.handle === handle; });
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    };

    btn.addEventListener('click', function () {
      let list = readList();
      const idx = list.findIndex(function (p) { return p.handle === handle; });
      if (idx >= 0) {
        list.splice(idx, 1);
        writeList(list);
        refresh();
        showToast('💔 Removido de favoritos');
      } else {
        list.unshift({
          handle: handle,
          title: btn.getAttribute('data-title') || '',
          image: btn.getAttribute('data-image') || '',
          price: btn.getAttribute('data-price') || '',
          url: btn.getAttribute('data-url') || '',
          ts: Date.now()
        });
        writeList(list);
        refresh();
        showToast('❤ Guardado en favoritos');
      }
    });

    refresh();
  })();

  /* ------------------------------------------------------------------------
     0d. RECENTLY VIEWED PRODUCTS — localStorage-based
  ------------------------------------------------------------------------ */
  (function () {
    const STORAGE_KEY = 'innovazone_recently_viewed';
    const MAX_ITEMS = 8;

    const productData = (function () {
      const r = document.querySelector('.prem');
      if (!r) return null;
      const id = r.getAttribute('data-product-id');
      const titleEl = r.querySelector('.prem-title');
      const mainImg = r.querySelector('#prem-gallery-img');
      const priceEl = r.querySelector('.prem-price__now');
      if (!id || !titleEl) return null;
      return {
        id: id,
        handle: location.pathname.replace(/^\/products\//, '').replace(/[\?#].*$/, ''),
        title: titleEl.textContent.trim(),
        image: mainImg ? mainImg.getAttribute('src') : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        url: location.pathname,
        ts: Date.now()
      };
    })();

    function readList() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function writeList(arr) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
    }

    // Record current product
    if (productData && productData.handle) {
      let list = readList().filter(function (p) { return p.handle !== productData.handle; });
      list.unshift(productData);
      list = list.slice(0, MAX_ITEMS);
      writeList(list);
    }

    // Render section with the OTHER recently-viewed products
    const section = document.getElementById('prem-recent-section');
    const rail = section ? section.querySelector('[data-recent-rail]') : null;
    if (section && rail) {
      const others = readList().filter(function (p) {
        return !productData || p.handle !== productData.handle;
      });
      if (others.length === 0) {
        section.hidden = true;
      } else {
        rail.innerHTML = '';
        others.forEach(function (p) {
          const a = document.createElement('a');
          a.className = 'prem-recent__card';
          a.href = p.url;
          a.innerHTML =
            (p.image ? '<div class="prem-recent__img"><img src="' + p.image + '" alt="" loading="lazy"></div>' : '<div class="prem-recent__img"></div>') +
            '<div class="prem-recent__title">' + escapeText(p.title) + '</div>' +
            (p.price ? '<div class="prem-recent__price">' + escapeText(p.price) + '</div>' : '');
          rail.appendChild(a);
        });
        section.hidden = false;
        section.classList.add('is-revealed');
      }
    }

    function escapeText(s) {
      const d = document.createElement('div');
      d.textContent = s || '';
      return d.innerHTML;
    }
  })();

  /* ------------------------------------------------------------------------
     0e. DESKTOP FLOATING CARD — shows when form scrolls out of view (≥1100px)
  ------------------------------------------------------------------------ */
  (function () {
    const card = document.getElementById('prem-floating-card');
    if (!card) return;

    let dismissed = sessionStorage.getItem('prem_floating_dismissed') === '1';
    if (dismissed) return;

    const submit = document.getElementById('prem-submit-btn');
    if (!submit) return;

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(function (entries) {
        if (window.innerWidth < 1100) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            card.classList.remove('is-visible');
            card.setAttribute('aria-hidden', 'true');
          } else {
            card.classList.add('is-visible');
            card.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0 });
      obs.observe(submit);
    }

    const closeBtn = card.querySelector('[data-floating-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        sessionStorage.setItem('prem_floating_dismissed', '1');
        card.classList.remove('is-visible');
        card.setAttribute('aria-hidden', 'true');
        card.style.display = 'none';
      });
    }

    const cta = card.querySelector('[data-floating-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        const form = document.getElementById('prem-purchase-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  })();

  /* ------------------------------------------------------------------------
     1. GALLERY — thumb click swaps main image OR plays product video
  ------------------------------------------------------------------------ */
  const galleryMain = root.querySelector('#prem-gallery-img');
  const thumbs = root.querySelectorAll('.prem-gallery__thumb');
  const galleryVideos = root.querySelectorAll('.prem-gallery__video');

  function premHideGalleryVideos() {
    galleryVideos.forEach(function (box) {
      box.hidden = true;
      const v = box.querySelector('video');
      if (v && typeof v.pause === 'function') {
        try { v.pause(); } catch (e) { /* ignore */ }
      }
    });
  }

  if (thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const type = thumb.getAttribute('data-media-type');
        const isVideo = type === 'video' || type === 'external_video';

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');

        if (isVideo) {
          const target = thumb.getAttribute('data-video-target');
          premHideGalleryVideos();
          if (galleryMain) galleryMain.hidden = true;
          const box = root.querySelector('.prem-gallery__video[data-video-target="' + target + '"]');
          if (box) {
            box.hidden = false;
            const v = box.querySelector('video');
            if (v && typeof v.play === 'function') {
              try { v.play(); } catch (e) { /* ignore */ }
            }
          }
        } else {
          const full = thumb.getAttribute('data-full');
          premHideGalleryVideos();
          if (galleryMain) {
            galleryMain.hidden = false;
            if (full) galleryMain.setAttribute('src', full);
          }
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     2. REVEAL ANIMATIONS — IntersectionObserver
  ------------------------------------------------------------------------ */
  const reveals = root.querySelectorAll('[data-prem-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    reveals.forEach(function (el) { io.observe(el); });
  } else {
    // No IO support — show everything immediately
    reveals.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* ------------------------------------------------------------------------
     3. MOBILE STICKY CTA — appears when purchase form scrolls out
  ------------------------------------------------------------------------ */
  const stickyCta = document.getElementById('prem-sticky-cta');
  const submitBtn = document.getElementById('prem-submit-btn');
  const stickyAddBtn = root.querySelector('[data-prem-sticky-add]');
  const targetForObserver = submitBtn || root.querySelector('.prem-purchase__submit');

  if (stickyCta && targetForObserver && 'IntersectionObserver' in window) {
    const ctaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('wa-float-up');
        } else {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
          document.body.classList.add('wa-float-up');
        }
      });
    }, { threshold: 0 });
    ctaObserver.observe(targetForObserver);

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        const form = document.getElementById('prem-purchase-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ------------------------------------------------------------------------
     4. CAROUSEL — recommended rail prev/next buttons
  ------------------------------------------------------------------------ */
  const rail = root.querySelector('[data-prem-rail]');
  const prevBtn = root.querySelector('[data-prem-rail-prev]');
  const nextBtn = root.querySelector('[data-prem-rail-next]');

  if (rail && (prevBtn || nextBtn)) {
    const scrollAmount = function () {
      // 1 card-worth, plus gap
      const firstCard = rail.querySelector('.prem-recommended__slide');
      if (!firstCard) return 240;
      const style = window.getComputedStyle(rail);
      const gap = parseInt(style.columnGap || style.gap || '16', 10);
      return firstCard.getBoundingClientRect().width + gap;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        rail.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rail.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  }

  /* ------------------------------------------------------------------------
     5. SHOPIFY PRODUCT RECOMMENDATIONS — async fetch
  ------------------------------------------------------------------------ */
  const recRail = root.querySelector('.prem-recommended__rail[data-recommendations-url]');
  if (recRail) {
    const url = recRail.getAttribute('data-recommendations-url');
    if (url) {
      fetch(url + '&section_id=product-recommendations')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          // Extract product cards from the section response
          const tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          const cards = tmp.querySelectorAll('.product-card, [data-product-card]');
          if (cards.length) {
            recRail.innerHTML = '';
            cards.forEach(function (card) {
              const slide = document.createElement('div');
              slide.className = 'prem-recommended__slide';
              slide.appendChild(card);
              recRail.appendChild(slide);
            });
          } else {
            // Fallback — try recommendations.json API
            const productId = root.getAttribute('data-product-id');
            if (productId) {
              fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  if (!data.products || !data.products.length) {
                    recRail.innerHTML = '<p class="prem-recommended__loading">No hay productos recomendados disponibles.</p>';
                    return;
                  }
                  recRail.innerHTML = data.products.map(function (p) {
                    const priceCRC = Math.round(p.price / 100).toLocaleString('es-CR');
                    return '<div class="prem-recommended__slide"><a href="' + p.url + '" class="prem-rec-card">' +
                      '<div class="prem-rec-card__img"><img src="' + p.featured_image + '" alt="' + (p.title || '') + '" loading="lazy"></div>' +
                      '<h3 class="prem-rec-card__title">' + p.title + '</h3>' +
                      '<span class="prem-rec-card__price">₡' + priceCRC + '</span>' +
                    '</a></div>';
                  }).join('');
                });
            }
          }
        })
        .catch(function () {
          recRail.innerHTML = '<p class="prem-recommended__loading">No se pudieron cargar los recomendados.</p>';
        });
    }
  }

  /* ------------------------------------------------------------------------
     6. PURCHASE FORM — live total + zone-filtered shipping + WhatsApp/checkout flow
  ------------------------------------------------------------------------ */
  const form = document.getElementById('prem-purchase-form');
  if (form) {
    const basePrice = parseInt(form.getAttribute('data-base-price'), 10) || 0;
    const sinpePct = parseInt(form.getAttribute('data-sinpe-pct'), 10) || 0;
    const waPhone = (form.getAttribute('data-wa-phone') || '').replace(/\D/g, '');
    const productTitle = form.getAttribute('data-product-title') || '';
    const variantId = form.getAttribute('data-variant-id') || '';
    // V41 — when set, premium.js routes the submit through this Vercel function
    // (creates Shopify Draft Order with exact PDP pricing). When empty, falls
    // back to the V36 unified-checkout flow (cart + redirect to /checkout).
    const orderApiUrl = (form.getAttribute('data-order-api-url') || '').trim();

    function fmt(n) {
      // Format integer with thousands separator (Costa Rica uses comma for thousands)
      return '₡' + Math.round(n).toLocaleString('es-CR');
    }

    function getSelectedRadio(name) {
      return form.querySelector('input[type="radio"][name="' + name + '"]:checked');
    }

    /* ---- Bulk tier ---- */
    const bulkQtyBlock = form.querySelector('[data-qty-block]');
    const bulkQtyInput = document.getElementById('prem-qty');

    /* ---- Warranty options: included tier per bulk pack ---- */
    // Single = base. 2-pack = 3 months included. 3+-pack = 12 months included.
    // When customer is in a higher tier, lock the lower warranty options.
    function syncWarrantyWithBulk() {
      const bulkRadio = getSelectedRadio('bulk_tier');
      if (!bulkRadio) return;
      const includedMonths = parseInt(bulkRadio.dataset.warrantyMonths, 10) || 1;

      const warrantyCards = form.querySelectorAll('input[name="warranty"]');
      let firstAvailable = null;
      warrantyCards.forEach(function (input) {
        const monthsTotal = parseInt(input.value, 10) || 1;
        const card = input.closest('.prem-radio-card');
        const labelEl = card ? card.querySelector('.prem-radio-card__label') : null;
        const priceEl = card ? card.querySelector('.prem-radio-card__price') : null;
        const originalLabel = input.dataset.label || (labelEl ? labelEl.textContent : '');

        if (monthsTotal < includedMonths) {
          // Lock it — already included for free via the bulk pack
          input.disabled = true;
          input.checked = false;
          if (card) card.classList.add('prem-radio-card--included');
          if (priceEl) priceEl.innerHTML = '<em>Ya incluido en tu pack</em>';
        } else if (monthsTotal === includedMonths) {
          // This tier IS what's included with the bulk — show as "incluido gratis"
          input.disabled = false;
          if (card) card.classList.remove('prem-radio-card--included');
          if (priceEl) {
            if (input.dataset.price === '0' || parseInt(input.dataset.price, 10) === 0 || includedMonths > 1) {
              priceEl.innerHTML = '<em>Incluido gratis</em>';
            }
          }
          // Auto-select if nothing else was selected
          if (firstAvailable === null) firstAvailable = input;
        } else {
          // Optional upgrade — restore original price label
          input.disabled = false;
          if (card) card.classList.remove('prem-radio-card--included');
          if (priceEl) {
            const price = parseInt(input.dataset.price, 10) || 0;
            if (price > 0) {
              priceEl.innerHTML = '+' + fmt(price);
            } else {
              priceEl.innerHTML = '<em>Gratis</em>';
            }
          }
          if (firstAvailable === null) firstAvailable = input;
        }
      });

      // If currently selected warranty got disabled, pick the included tier (or first available)
      const currentSelected = getSelectedRadio('warranty');
      if (!currentSelected || currentSelected.disabled) {
        if (firstAvailable) firstAvailable.checked = true;
      }
    }

    function getBulkSelection() {
      const radio = getSelectedRadio('bulk_tier');
      if (!radio) return { tier: 'single', units: 1, unitPrice: basePrice, label: '1 unidad' };
      const tier = radio.value;
      const units = parseInt(radio.dataset.units, 10) || 1;
      const unitPrice = parseInt(radio.dataset.unitPrice, 10) || basePrice;
      const label = radio.dataset.label || tier;

      // Stepper de cantidad manda las unidades al MISMO precio por unidad — sin
      // descuento por volumen (packs 2u/mayoreo retirados, Kevin 2026-07-09).
      let actualUnits = units;
      if (bulkQtyInput) {
        actualUnits = parseInt(bulkQtyInput.value, 10) || units;
        if (actualUnits < 1) actualUnits = 1;
      }

      return { tier: tier, units: actualUnits, unitPrice: unitPrice, label: label, radio: radio };
    }

    function updateBulkQtyVisibility() {
      // Stepper siempre visible: precio único, sin tiers de descuento. Kevin 2026-07-09.
      if (bulkQtyBlock) bulkQtyBlock.hidden = false;
    }

    /* ---- Installments selector ---- */
    const installmentsBlock = form.querySelector('[data-installments-block]');
    const installmentsSelect = document.getElementById('prem-installments-select');
    const installmentsPreview = form.querySelector('[data-installments-preview]');

    function updateInstallmentsVisibility() {
      const paymentRadio = getSelectedRadio('payment');
      const isCard = paymentRadio && paymentRadio.value === 'card';
      if (installmentsBlock) installmentsBlock.hidden = !isCard;
    }

    /* ---- Dynamic installments: tier follows the LIVE total, not base price ---- */
    function computeMaxInstallments(totalCRC) {
      if (totalCRC >= 60000) return 12;
      if (totalCRC >= 50000) return 10;
      if (totalCRC >= 40000) return 6;
      if (totalCRC >= 30000) return 3;
      return 0;
    }

    function updateInstallmentsOptions(totalCRC) {
      if (!installmentsSelect) return;
      const max = computeMaxInstallments(totalCRC);

      // Show/hide options whose data-min-amount exceeds current total
      const opts = Array.from(installmentsSelect.options);
      let firstAvailable = null;
      opts.forEach(function (opt) {
        const minAmount = parseInt(opt.getAttribute('data-min-amount'), 10);
        const months = parseInt(opt.value, 10) || 1;
        const qualifies = isNaN(minAmount) || totalCRC >= minAmount;
        opt.hidden = !qualifies;
        opt.disabled = !qualifies;
        if (qualifies && firstAvailable === null && months > 1) {
          firstAvailable = opt;
        }
      });

      // If currently selected option is now disabled, reset to first available or 1
      const currentOpt = installmentsSelect.options[installmentsSelect.selectedIndex];
      if (currentOpt && currentOpt.disabled) {
        installmentsSelect.value = firstAvailable ? firstAvailable.value : '1';
      }

      // Update the tarjeta card description "Hasta X cuotas"
      const maxLabel = document.querySelector('[data-tarjeta-max]');
      if (maxLabel) maxLabel.textContent = String(max || 1);

      // Hide the tarjeta card itself if max < 3 (product too cheap for installments)
      const tarjetaCard = document.querySelector('[data-card-tarjeta]');
      if (tarjetaCard) {
        if (max < 3) {
          tarjetaCard.hidden = true;
          // If user had tarjeta selected, switch to SINPE
          const cardRadio = tarjetaCard.querySelector('input[type="radio"]');
          if (cardRadio && cardRadio.checked) {
            const sinpe = form.querySelector('input[name="payment"][value="sinpe"]');
            if (sinpe) sinpe.checked = true;
          }
        } else {
          tarjetaCard.hidden = false;
        }
      }
    }

    function updateInstallmentsPreview() {
      if (!installmentsSelect || !installmentsPreview) return;
      const totals = recalcTotals();
      const count = parseInt(installmentsSelect.value, 10) || 1;
      const perMonth = Math.round(totals.total / count);
      if (count > 1) {
        installmentsPreview.innerHTML = count + ' cuotas de <strong>' + fmt(perMonth) + '</strong>/mes · 0% interés';
      } else {
        installmentsPreview.innerHTML = 'Pago único de <strong>' + fmt(totals.total) + '</strong>';
      }
    }

    if (installmentsSelect) {
      installmentsSelect.addEventListener('change', updateInstallmentsPreview);
    }

    /* ---- Totals (used by recalc + installments preview + submit) ---- */
    function recalcTotals() {
      const warrantyRadio = getSelectedRadio('warranty');
      const shippingRadio = getSelectedRadio('shipping');
      const paymentRadio = getSelectedRadio('payment');
      const bulk = getBulkSelection();

      // Products subtotal — bulk tier dictates per-unit price
      let productsSubtotal;
      if (bulk.tier === 'two_pack') {
        // Use first + second specific pricing if available
        const firstPrice = bulk.radio && bulk.radio.dataset.firstPrice
          ? parseInt(bulk.radio.dataset.firstPrice, 10) || basePrice
          : basePrice;
        const secondPrice = bulk.radio && bulk.radio.dataset.secondPrice
          ? parseInt(bulk.radio.dataset.secondPrice, 10) || basePrice
          : basePrice;
        productsSubtotal = firstPrice + secondPrice;
      } else {
        productsSubtotal = bulk.unitPrice * bulk.units;
      }

      const warrantyUnitPrice = warrantyRadio ? parseInt(warrantyRadio.dataset.price, 10) || 0 : 0;
      // Warranty applied per unit (each unit gets covered if customer pays it)
      const warrantyPrice = warrantyUnitPrice * bulk.units;
      const shippingPrice = shippingRadio ? parseInt(shippingRadio.dataset.price, 10) || 0 : 0;
      const discountPct = paymentRadio ? parseInt(paymentRadio.dataset.discountPct, 10) || 0 : 0;

      // Cross-sell add-ons (Combina con)
      const xsellChecked = form.querySelectorAll('input[name="xsell"]:checked');
      let xsellTotal = 0;
      const xsellList = [];
      xsellChecked.forEach(function (cb) {
        const p = parseInt(cb.dataset.xsellPrice, 10) || 0;
        // V41.9 — capturamos también el precio original para que el Worker
        // pueda enviar el descuento correcto al draft order.
        const origP = parseInt(cb.dataset.xsellOriginalPrice, 10) || p;
        xsellTotal += p;
        xsellList.push({
          title: cb.value,
          price: p,
          originalPrice: origP,
          handle: cb.dataset.xsellHandle,
          variantId: cb.dataset.xsellVariantId
        });
      });

      const subtotal = productsSubtotal + warrantyPrice + shippingPrice + xsellTotal;
      const discount = Math.round(subtotal * discountPct / 100);
      const total = subtotal - discount;

      // V39 — bulk savings = what they'd pay at retail × qty MINUS the
      // bulk-discounted productsSubtotal. Helps the merchant reconcile the
      // Shopify line-item total vs the PDP quote.
      const fullRetail = basePrice * bulk.units;
      const bulkSavings = Math.max(0, fullRetail - productsSubtotal);

      return {
        subtotal: subtotal,
        discount: discount,
        total: total,
        productsSubtotal: productsSubtotal,
        bulkSavings: bulkSavings,
        warrantyPrice: warrantyPrice,
        shippingPrice: shippingPrice,
        xsellTotal: xsellTotal,
        xsellList: xsellList,
        bulk: bulk,
        warrantyRadio: warrantyRadio,
        shippingRadio: shippingRadio,
        paymentRadio: paymentRadio
      };
    }

    function recalc() {
      updateBulkQtyVisibility();
      syncWarrantyWithBulk();
      const totals = recalcTotals();

      // Update product line label to show qty if > 1
      const productLine = form.querySelector('.prem-purchase__line:first-child span:first-child');
      const productAmount = form.querySelector('.prem-purchase__line:first-child span:last-child');
      if (productLine && productAmount) {
        if (totals.bulk.units > 1) {
          productLine.textContent = productTitle + ' × ' + totals.bulk.units;
        } else {
          productLine.textContent = productTitle;
        }
        productAmount.textContent = fmt(totals.productsSubtotal);
      }

      // Update summary lines
      const warrantyLine = form.querySelector('[data-line="warranty"]');
      const warrantyAmount = form.querySelector('[data-warranty-line]');
      const warrantyLabel = form.querySelector('[data-warranty-label]');
      if (warrantyLine && warrantyAmount) {
        if (totals.warrantyPrice > 0) {
          warrantyLine.hidden = false;
          warrantyAmount.textContent = '+' + fmt(totals.warrantyPrice);
          if (warrantyLabel && totals.warrantyRadio) {
            const unitSuffix = totals.bulk.units > 1 ? ' × ' + totals.bulk.units : '';
            warrantyLabel.textContent = 'Garantía ' + totals.warrantyRadio.dataset.label + unitSuffix;
          }
        } else {
          warrantyLine.hidden = true;
        }
      }

      // Cross-sell summary line
      const xsellLine = form.querySelector('[data-line="xsell"]');
      const xsellAmount = form.querySelector('[data-xsell-line]');
      const xsellLabel = form.querySelector('[data-xsell-label]');
      if (xsellLine && xsellAmount) {
        if (totals.xsellTotal > 0) {
          xsellLine.hidden = false;
          xsellAmount.textContent = '+' + fmt(totals.xsellTotal);
          if (xsellLabel) {
            const count = totals.xsellList.length;
            xsellLabel.textContent = 'Combina con (' + count + ')';
          }
        } else {
          xsellLine.hidden = true;
        }
      }

      const shippingLine = form.querySelector('[data-line="shipping"]');
      const shippingAmount = form.querySelector('[data-shipping-line]');
      const shippingLabel = form.querySelector('[data-shipping-label]');
      if (shippingLine && shippingAmount) {
        if (totals.shippingPrice > 0) {
          shippingLine.hidden = false;
          shippingAmount.textContent = '+' + fmt(totals.shippingPrice);
          if (shippingLabel && totals.shippingRadio) {
            shippingLabel.textContent = 'Envío ' + totals.shippingRadio.dataset.label;
          }
        } else {
          shippingLine.hidden = true;
        }
      }

      const discountLine = form.querySelector('[data-line="discount"]');
      const discountAmount = form.querySelector('[data-discount-line]');
      if (discountLine && discountAmount) {
        if (totals.discount > 0) {
          discountLine.hidden = false;
          discountAmount.textContent = '−' + fmt(totals.discount);
        } else {
          discountLine.hidden = true;
        }
      }

      // SINPE preview savings (shown even when not selected, as anchor)
      const sinpeRadio = form.querySelector('input[name="payment"][value="sinpe"]');
      const sinpeSavingsEl = form.querySelector('[data-sinpe-savings]');
      if (sinpeRadio && sinpeSavingsEl) {
        const previewSavings = Math.round((basePrice + totals.warrantyPrice + totals.shippingPrice) * sinpePct / 100);
        sinpeSavingsEl.textContent = 'Ahorrás ' + fmt(previewSavings);
      }

      const totalEl = form.querySelector('[data-total]');
      if (totalEl) totalEl.textContent = fmt(totals.total);

      // PAGO reactivo (Phase 4 / PAY-03) — repintar también el total del modal
      // post-pedido en cada recalc, para que cambiar el radio de pago (p.ej. SINPE
      // −15%) actualice [data-post-total] en vivo. totals.total YA refleja el −15%
      // vía recalcTotals (L823); cero cálculo nuevo aquí.
      var postTotalEl = form.querySelector('#prem-post-order [data-post-total]');
      if (postTotalEl) postTotalEl.textContent = fmt(totals.total);

      updateInstallmentsOptions(totals.total);
      updateInstallmentsVisibility();
      updateInstallmentsPreview();

      return totals;
    }

    // Recalc on any form change
    form.addEventListener('change', recalc);
    form.addEventListener('input', recalc);
    recalc();

    /* ---- Sticky-CTA enable gate (Phase 1, Plan 03 — FLOW-04 / INT-02) ----
       The sticky "Hacer pedido" button is disabled until the customer has
       given (a) a valid CR phone AND (b) a location. We REUSE the existing
       predicates — the 8-digit/506 rule from customValidate('phone') and the
       GPS-OR-address OR-gate from validateForm() — instead of writing new
       regexes (RESEARCH "Don't Hand-Roll"). Paid shipping does NOT affect this
       gate (D-06 / SHIP-01): only phone + location matter. The existing submit
       handler already early-returns when submitBtn.disabled, so toggling
       .disabled here IS the gate. */
    const ctaHelp = form.querySelector('[data-cta-help]');
    function captureReady() {
      const phoneInput = form.querySelector('[name="phone"]');
      const digits = ((phoneInput && phoneInput.value) || '').replace(/\D/g, '');
      // Same predicate as customValidate('phone'): 8 digits, or 11 starting 506.
      const phoneOk = digits.length === 8 || (digits.length === 11 && digits.indexOf('506') === 0);
      // Same OR-gate as validateForm(): GPS present OR address >= 5 chars.
      const latInput = form.querySelector('[name="geo_lat"]');
      const lngInput = form.querySelector('[name="geo_lng"]');
      const hasGeo = !!(latInput && latInput.value && lngInput && lngInput.value);
      const addrInput = form.querySelector('[name="address"]');
      const addr = (addrInput && addrInput.value) || '';
      const hasLoc = hasGeo || addr.trim().length >= 5;
      return phoneOk && hasLoc;
    }
    function updateCaptureGate() {
      if (!submitBtn) return;
      const ready = captureReady();
      submitBtn.disabled = !ready;
      if (ctaHelp) ctaHelp.hidden = ready;
    }
    // Re-evaluate on the same input/change stream recalc listens on.
    form.addEventListener('input', updateCaptureGate);
    form.addEventListener('change', updateCaptureGate);
    // GPS resolves asynchronously (no form input event) — refresh on prem:geo.
    document.addEventListener('prem:geo', updateCaptureGate);
    updateCaptureGate();

    /* ---- Submit handler — branches by payment method ---- */
    function buildOrderLines(totals, data, paymentSpecific) {
      const warrantyLabel = totals.warrantyRadio ? totals.warrantyRadio.dataset.label : 'Solo estándar';
      const shippingLabel = totals.shippingRadio ? totals.shippingRadio.dataset.label : '—';
      const paymentLabel = totals.paymentRadio ? totals.paymentRadio.dataset.label : '—';
      const units = totals.bulk.units;
      const tierLabel = totals.bulk.label + (units > 1 ? ' (' + units + ' unidades)' : '');

      const giftRadio = getSelectedRadio('gift');
      const giftLabel = giftRadio ? (giftRadio.dataset.giftLabel || giftRadio.value) : null;
      const giftSelected = giftLabel && giftLabel !== 'Sin regalo' && giftLabel !== '' ? giftLabel : null;

      const lines = [
        '*Nuevo pedido InnovaZone*',
        '',
        '📦 *Producto:* ' + productTitle,
        '📊 *Cantidad / Tier:* ' + tierLabel,
        '💰 *Subtotal producto(s):* ' + fmt(totals.productsSubtotal),
        '🛡 *Garantía:* ' + warrantyLabel + (totals.warrantyPrice > 0 ? ' (+' + fmt(totals.warrantyPrice) + ')' : ''),
        '🚚 *Envío:* ' + shippingLabel + (totals.shippingPrice > 0 ? ' (+' + fmt(totals.shippingPrice) + ')' : ' (gratis)'),
        '💳 *Pago:* ' + paymentLabel + (totals.discount > 0 ? ' (−' + fmt(totals.discount) + ' descuento)' : '')
      ];

      if (giftSelected) {
        lines.push('🎁 *Regalo gratis solicitado:* ' + giftSelected);
      }

      if (totals.xsellList && totals.xsellList.length > 0) {
        lines.push('');
        lines.push('➕ *Combina con (add-ons):*');
        totals.xsellList.forEach(function (x) {
          lines.push('  · ' + x.title + ' — ' + fmt(x.price));
        });
      }

      if (paymentSpecific) lines.push(paymentSpecific);

      lines.push(
        '',
        '*TOTAL: ' + fmt(totals.total) + '*',
        '',
        '👤 *Datos del comprador:*',
        'Nombre: ' + data.name,
        'Teléfono: ' + data.phone,
        'Correo: ' + data.email
      );
      if (data.cedula) lines.push('Cédula: ' + data.cedula);
      lines.push(
        '',
        '📍 *Dirección de entrega:*',
        'Provincia: ' + data.province,
        'Cantón: ' + data.canton,
        'Distrito: ' + data.district,
        'Dirección exacta: ' + data.address
      );
      if (data.geo_lat && data.geo_lng) {
        lines.push(
          '🗺️ *Ubicación GPS:* https://maps.google.com/?q=' + data.geo_lat + ',' + data.geo_lng +
          (data.geo_accuracy ? ' (±' + Math.round(parseFloat(data.geo_accuracy)) + ' m)' : '')
        );
      } else {
        // Sin pin GPS: link de búsqueda Google Maps con la dirección escrita,
        // para que SIEMPRE llegue un enlace de ubicación clickeable.
        var addrQuery = [data.address, data.district, data.canton, data.province, 'Costa Rica']
          .filter(function (p) { return p && String(p).trim(); })
          .join(', ');
        lines.push(
          '🗺️ *Ubicación (aprox. por dirección):* https://maps.google.com/?q=' + encodeURIComponent(addrQuery)
        );
      }
      lines.push(
        '',
        '_Generado desde innovazone.shop_'
      );

      return lines.join('\n');
    }

    /* ---- Post-order screen (Phase 3 / B1·B2·B3) ----------------------------
       Tras crear la orden (seam #order-created), en vez de RECARGAR la página
       revelamos el modal server-rendered #prem-post-order SIN recargar: el form
       sigue vivo, así recalcTotals()/recalc() y el listener `change` (L945)
       siguen funcionando. Reubicamos (appendChild, MOVE no clone) los fieldsets
       garantía / bulk_tier (up-sell) / xsell a sus slots DENTRO del mismo form,
       para que recalcTotals() los siga leyendo por nombre (Pitfall 4).
       El total reusa recalcTotals().total — con COD checked discount===0, así NO
       se re-aplica el 15% SINPE (A1). NO hay un segundo POST al Worker: la
       actualización es por WhatsApp + lead Kommo manual (B1 / POST-04 MVP). */
    var lastOrderName = '';        // capturado para la reapertura WhatsApp (Task 2)
    var postBuyerData = null;      // snapshot de los datos del comprador (closure submit)
    var postPaymentSpecific = '';  // nota de pago base reutilizable

    function showPostOrderScreen(orderName, buyerData, basePaymentSpecific) {
      var postEl = document.getElementById('prem-post-order');
      // Fallback: producto sin el markup 03-01 → conservar el comportamiento previo
      // (redirect a la página thank-you). ESTE es el único window.location.href='/?order='.
      if (!postEl) {
        setTimeout(function () {
          window.location.href = '/?order=' + encodeURIComponent(orderName) + '#order-created';
        }, 700);
        return;
      }

      lastOrderName = orderName || '';
      if (buyerData) postBuyerData = buyerData;
      if (typeof basePaymentSpecific === 'string') postPaymentSpecific = basePaymentSpecific;

      // Nombre de la orden — XSS-safe (textContent, nunca innerHTML)
      var nameEl = postEl.querySelector('[data-post-order-name]');
      if (nameEl) nameEl.textContent = lastOrderName;

      // Reubicar (MOVE, no clone) los fieldsets de palancas a sus slots del modal.
      // Permanecen DENTRO de <form id="prem-purchase-form"> → recalcTotals() los lee.
      var warrantyInput = form.querySelector('input[name="warranty"]');
      var warrantyFs = warrantyInput ? warrantyInput.closest('fieldset') : null;
      var warrantySlot = postEl.querySelector('[data-post-warranty-slot]');
      if (warrantyFs && warrantySlot) warrantySlot.appendChild(warrantyFs);

      var bulkFs = form.querySelector('fieldset.prem-bulk');
      var upsellSlot = postEl.querySelector('[data-post-upsell-slot]');
      if (bulkFs && upsellSlot) upsellSlot.appendChild(bulkFs);

      var xsellFs = form.querySelector('fieldset.prem-xsell');
      var xsellSlot = postEl.querySelector('[data-post-xsell-slot]');
      if (xsellFs && xsellSlot) xsellSlot.appendChild(xsellFs);

      // PAGO (Phase 4 / PAY-01·PAY-02) — MOVE el fieldset name="payment" (radios
      // cod/sinpe/card + el [data-installments-block] que vive dentro) al slot del
      // modal. appendChild = MOVE, nunca cloneNode (Pitfall 4: input[name=payment]
      // duplicado). El fieldset permanece DENTRO del <form> → recalcTotals() lo lee.
      var paymentInput = form.querySelector('input[name="payment"]');
      var paymentFs = paymentInput ? paymentInput.closest('fieldset') : null;
      var paymentSlot = postEl.querySelector('[data-post-payment-slot]');
      if (paymentFs && paymentSlot) paymentSlot.appendChild(paymentFs);

      // Ocultar la captura (los pasos + el sticky CTA) SIN ocultar el modal,
      // que vive dentro del mismo .prem-flow. Movemos los fieldsets ANTES de
      // ocultar los pasos para no perderlos. (B2: revelado por estado de acción.)
      var flow = form.querySelector('.prem-flow');
      if (flow) {
        var hideTargets = flow.querySelectorAll('[data-step], [data-prem-cta]');
        Array.prototype.forEach.call(hideTargets, function (el) {
          if (el.id === 'prem-post-order' || el.closest('#prem-post-order')) return;
          el.hidden = true;
        });
      }

      // Revelar el modal por estado HTML `hidden` (B2 — nunca opacity/observer).
      postEl.hidden = false;

      // Sincronizar garantía↔bulk y repintar el total con recalcTotals() vía recalc().
      try { syncWarrantyWithBulk(); } catch (e) {}
      recalc();
      var pt = postEl.querySelector('[data-post-total]');
      if (pt) pt.textContent = fmt(recalcTotals().total);

      // Llevar el foco al modal para accesibilidad y scroll.
      try { postEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    /* ---- Confirmar mejoras → reabrir WhatsApp con extras + nuevo total --------
       (POST-04 / B1) Al confirmar, recomputamos recalcTotals() y reabrimos
       WhatsApp con los extras que el cliente agregó (garantía>1m / más unidades /
       cross-sell) + el NUEVO total. El mensaje llega al número del negocio y el
       EQUIPO ajusta el lead Kommo manualmente. NO hay segundo POST al Worker
       (sin orden duplicada, B1). El total preserva discount===0 re-verificando
       COD :checked antes de recalcTotals (A1) — nunca re-aplica el 15% SINPE. */
    var postConfirmBtn = document.querySelector('[data-post-confirm]');
    if (postConfirmBtn) {
      postConfirmBtn.addEventListener('click', function () {
        // Anti doble-submit (T-03-04): deshabilitar tras el primer click.
        if (postConfirmBtn.disabled) return;
        postConfirmBtn.disabled = true;

        // Phase 4: el cliente ELIGE el método de pago en el modal. El override
        // COD-forzado de Fase 3 (A1) queda anulado — forzarlo impediría el 15%
        // SINPE (Pitfall 2). recalcTotals deriva el descuento UNA vez del radio
        // :checked (sin doble-15%, sin segundo fetch al Worker — B1).
        var totals = recalcTotals();
        var paymentValue = totals.paymentRadio ? totals.paymentRadio.value : 'cod';

        // Nota específica por método (textContent/concatenación con literales —
        // cero innerHTML con valores de cliente, T-04-04 XSS).
        var paySpecific;
        if (paymentValue === 'sinpe') {
          paySpecific = '⚠ Cliente cambió a SINPE Móvil (pago anticipado, precio lleno — sin descuento web). ' +
                        'Enviale el número SINPE y pedí el comprobante.';
        } else if (paymentValue === 'card') {
          var instSel = form.querySelector('select[name="installments"]');
          var cuotas = instSel ? instSel.value : '1';
          paySpecific = '💳 Cliente quiere tarjeta, ' + cuotas + ' cuotas 0%. ' +
                        'Coordinar el cobro Tilopay y enviarle el link de pago.';
        } else {
          paySpecific = '💵 Pago contra entrega. Paga al mensajero al recibir.';
        }

        // Componer el mensaje de actualización. Reutilizamos buildOrderLines con
        // el snapshot del comprador capturado en el seam (postBuyerData); si no
        // está disponible, reconstruimos el set mínimo de extras desde totals.
        var msg;
        if (postBuyerData) {
          msg = '🔁 *Actualización del pedido ' + lastOrderName + '*\n' +
                'El cliente agregó mejoras a su pedido:\n\n' +
                buildOrderLines(totals, postBuyerData, paySpecific);
        } else {
          var extras = [];
          if (totals.warrantyRadio && totals.warrantyPrice > 0) {
            extras.push('  · Garantía: ' + (totals.warrantyRadio.dataset.label || '') +
                        ' (+' + fmt(totals.warrantyPrice) + ')');
          }
          if (totals.bulk && totals.bulk.units > 1) {
            extras.push('  · Cantidad: ' + (totals.bulk.label || '') +
                        ' (' + totals.bulk.units + ' unidades)');
          }
          if (totals.xsellList && totals.xsellList.length > 0) {
            totals.xsellList.forEach(function (x) {
              extras.push('  · ' + x.title + ' — ' + fmt(x.price));
            });
          }
          msg = '🔁 *Actualización del pedido ' + lastOrderName + '*\n' +
                'Agregar a mi pedido:\n' +
                (extras.length ? extras.join('\n') : '  (sin cambios)') +
                '\n\n' + paySpecific +
                '\n\n— NUEVO TOTAL: ' + fmt(totals.total);
        }

        var url = 'https://wa.me/' + waPhone + '?text=' + encodeURIComponent(msg);
        try { window.open(url, '_blank', 'noopener'); } catch (e) {}
        try { showToast('✓ Mejoras enviadas por WhatsApp'); } catch (e) {}
      });
    }

    // [data-post-skip] es un <a href="/"> server-rendered: navega a / de forma
    // nativa (cerrar sin extras). No requiere JS adicional.

    /* ---- Conditional sub-questions for shipping options ----
       Cedula block: only when Correos de CR (Correos requires ID for delivery).
       Encomienda block: only when Encomienda mismo día (optional courier picker). */
    const cedulaBlock = form.querySelector('[data-cedula-block]');
    const cedulaInput = cedulaBlock ? cedulaBlock.querySelector('input[name="cedula"]') : null;
    const encomiendaBlock = form.querySelector('[data-encomienda-sub]');

    function updateCedulaVisibility() {
      const ship = getSelectedRadio('shipping');
      const shipValue = ship ? ship.value : '';

      // Cédula — OPCIONAL (spec 2026-05-22). Se muestra como dato útil cuando el
      // envío es Correos de CR, pero nunca bloquea el pedido.
      if (cedulaBlock) {
        const isCorreos = shipValue === 'correos';
        cedulaBlock.hidden = !isCorreos;
        if (cedulaInput) {
          cedulaInput.removeAttribute('required');
          if (!isCorreos) {
            cedulaInput.value = '';
            clearFieldError('cedula');
          }
        }
      }

      // Encomienda courier sub-question
      if (encomiendaBlock) {
        encomiendaBlock.hidden = shipValue !== 'encomienda';
      }
    }

    /* ---- Per-field validation with inline errors ---- */
    function markFieldError(fieldName, message) {
      const input = form.querySelector('[name="' + fieldName + '"]');
      const errorEl = form.querySelector('[data-error-for="' + fieldName + '"]');
      if (input) input.classList.add('prem-input--error');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.add('is-visible');
      }
    }

    function clearFieldError(fieldName) {
      const input = form.querySelector('[name="' + fieldName + '"]');
      const errorEl = form.querySelector('[data-error-for="' + fieldName + '"]');
      if (input) input.classList.remove('prem-input--error');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    function validateForm(data) {
      // Campos OBLIGATORIOS: teléfono + (dirección o GPS) + envío + EMAIL.
      // (2026-07-03: correo requerido para enviarle factura + garantía por correo.)
      // Nombre, provincia, cantón, distrito y cédula son OPCIONALES.
      const errors = [];

      // Teléfono — único contacto obligatorio
      const phoneDigits = (data.phone || '').replace(/\D/g, '');
      if (!data.phone) {
        errors.push({ field: 'phone', message: 'Falta su teléfono — lo usamos para contactarle por WhatsApp.' });
      } else if (phoneDigits.length < 8) {
        errors.push({ field: 'phone', message: 'El teléfono debe tener al menos 8 dígitos.' });
      }

      // Dirección O ubicación GPS — al menos una para que el mensajero le encuentre
      const hasGeo = !!(data.geo_lat && data.geo_lng);
      const hasAddress = !!(data.address && data.address.trim().length >= 5);
      if (!hasGeo && !hasAddress) {
        errors.push({ field: 'address', message: 'Escriba la dirección exacta o use el botón de ubicación GPS.' });
      }

      // Email — OBLIGATORIO (para enviarle su factura + garantía por correo)
      if (data.email && !/^\S+@\S+\.\S+$/.test(data.email)) {
        errors.push({ field: 'email', message: 'Revise el formato del correo (ej: nombre@dominio.com).' });
      }

      return errors;
    }

    // Clear field error as soon as user types/changes
    ['name', 'phone', 'email', 'province', 'canton', 'district', 'address', 'cedula'].forEach(function (fieldName) {
      const input = form.querySelector('[name="' + fieldName + '"]');
      if (!input) return;
      input.addEventListener('input', function () { clearFieldError(fieldName); });
      input.addEventListener('change', function () { clearFieldError(fieldName); });
    });

    /* ---- Envío → momento de pago (spec 2026-05-22, modo "Flexible") ----
       Correos / Encomienda  = pago ANTICIPADO  → COD oculto (SINPE/Tarjeta).
       Express / Fuera GAM / Prioritario = contra entrega → COD visible y por
       defecto, pero SINPE/Tarjeta siguen disponibles (el cliente puede prepagar).
       SINPE Móvil es siempre pago anticipado. */
    const PREPAID_SHIP = ['correos', 'encomienda'];
    let lastShipPrepaid = null;
    function updatePaymentForShipping() {
      const ship = getSelectedRadio('shipping');
      const shipVal = ship ? ship.value : '';
      const isPrepaid = PREPAID_SHIP.indexOf(shipVal) >= 0;

      const codRadio = form.querySelector('input[name="payment"][value="cod"]');
      const codCard = codRadio ? codRadio.closest('.prem-radio-card') : null;
      const sinpeRadio = form.querySelector('input[name="payment"][value="sinpe"]');
      const note = form.querySelector('[data-payment-timing]');

      // Mostrar/ocultar COD según el envío
      if (codCard) codCard.hidden = isPrepaid;
      if (codRadio) codRadio.disabled = isPrepaid;

      if (isPrepaid) {
        // COD no aplica → si estaba elegido, pasar a SINPE (anticipado)
        if (codRadio && codRadio.checked && sinpeRadio) sinpeRadio.checked = true;
      } else if (lastShipPrepaid === true && codRadio) {
        // Acaba de pasar de anticipado → contra entrega: COD por defecto
        codRadio.checked = true;
      }
      lastShipPrepaid = isPrepaid;

      if (note) {
        // Kevin 3-oct: fuera del GAM el envío ₡2.900 va adelantado por SINPE y el producto al recibir.
        note.textContent = isPrepaid
          ? 'Con este envío el pago es por adelantado (SINPE Móvil o tarjeta).'
          : shipVal === 'fuera_gam'
            ? 'Fuera del GAM: primero paga el envío de ₡2.900 por adelantado por SINPE Móvil, y el producto lo paga al recibir.'
            : 'Con este envío puede pagar al recibir (contra entrega), o adelantado por SINPE/tarjeta.';
      }
    }

    // Listen to shipping change to toggle cedula + payment timing
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'shipping') {
        updateCedulaVisibility();
        updatePaymentForShipping();
        recalc();
      }
    });
    updateCedulaVisibility();
    updatePaymentForShipping();

    /* ---- "Hablar con asesor" button — sends current form state as a query ---- */
    const advisorBtn = form.querySelector('[data-advisor-btn]');
    if (advisorBtn) {
      advisorBtn.addEventListener('click', function () {
        const fd = new FormData(form);
        const totals = recalcTotals();
        const lines = [
          '*Consulta sobre ' + productTitle + '*',
          '',
          'Hola, tengo dudas sobre este producto. Estos son los datos que llevo llenos:'
        ];

        const name = (fd.get('name') || '').toString().trim();
        const phone = (fd.get('phone') || '').toString().trim();
        const email = (fd.get('email') || '').toString().trim();
        const province = (fd.get('province') || '').toString().trim();
        const canton = (fd.get('canton') || '').toString().trim();
        const district = (fd.get('district') || '').toString().trim();
        const address = (fd.get('address') || '').toString().trim();

        if (name) lines.push('Nombre: ' + name);
        if (phone) lines.push('Teléfono: ' + phone);
        if (email) lines.push('Correo: ' + email);
        if (province) lines.push('Provincia: ' + province);
        if (canton) lines.push('Cantón: ' + canton);
        if (district) lines.push('Distrito: ' + district);
        if (address) lines.push('Dirección: ' + address);

        lines.push('');
        lines.push('Lo que llevo elegido:');
        lines.push('• Tier: ' + (totals.bulk ? totals.bulk.label : '—'));
        if (totals.warrantyRadio) lines.push('• Garantía: ' + totals.warrantyRadio.dataset.label);
        if (totals.shippingRadio) lines.push('• Envío: ' + totals.shippingRadio.dataset.label);
        if (totals.paymentRadio) lines.push('• Pago: ' + totals.paymentRadio.dataset.label);
        const giftR = getSelectedRadio('gift');
        if (giftR && giftR.value !== 'Sin regalo' && giftR.value !== '') {
          lines.push('• Regalo: ' + (giftR.dataset.giftLabel || giftR.value));
        }
        lines.push('• Total estimado: ' + fmt(totals.total));
        lines.push('');
        lines.push('¿Me podés ayudar a aclarar mis dudas?');

        const url = 'https://wa.me/' + waPhone + '?text=' + encodeURIComponent(lines.join('\n'));
        window.open(url, '_blank', 'noopener');
      });
    }

    function setSubmitLoading(loading, label) {
      if (!submitBtn) return;
      submitBtn.disabled = !!loading;
      if (loading) {
        submitBtn.classList.add('is-loading');
        const lbl = submitBtn.querySelector('[data-submit-label]');
        if (lbl) lbl.textContent = label || 'PROCESANDO…';
      } else {
        submitBtn.classList.remove('is-loading');
        const lbl = submitBtn.querySelector('[data-submit-label]');
        if (lbl) lbl.textContent = 'RESERVAR PEDIDO';
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn && submitBtn.disabled) return;

      const fd = new FormData(form);
      const data = {
        name: (fd.get('name') || '').toString().trim(),
        phone: (fd.get('phone') || '').toString().trim(),
        email: (fd.get('email') || '').toString().trim(),
        province: (fd.get('province') || '').toString().trim(),
        canton: (fd.get('canton') || '').toString().trim(),
        district: (fd.get('district') || '').toString().trim(),
        address: (fd.get('address') || '').toString().trim(),
        cedula: (fd.get('cedula') || '').toString().trim(),
        installments: (fd.get('installments') || '1').toString().trim(),
        geo_lat: (fd.get('geo_lat') || '').toString().trim(),
        geo_lng: (fd.get('geo_lng') || '').toString().trim(),
        geo_accuracy: (fd.get('geo_accuracy') || '').toString().trim()
      };

      // Clear all previous error states first
      ['name','phone','email','province','canton','district','address','cedula'].forEach(clearFieldError);
      const errorBanner = form.querySelector('[data-form-errors]');
      const errorList = form.querySelector('[data-form-errors-list]');
      if (errorBanner) errorBanner.hidden = true;
      if (errorList) errorList.innerHTML = '';

      // Validate
      const errors = validateForm(data);
      if (errors.length > 0) {
        // Mark each field individually (red border + inline message)
        errors.forEach(function (err) { markFieldError(err.field, err.message); });

        // Populate the form-level error banner with the full list
        if (errorBanner && errorList) {
          errorList.innerHTML = '';
          errors.forEach(function (err) {
            const li = document.createElement('li');
            li.textContent = err.message;
            errorList.appendChild(li);
          });
          errorBanner.hidden = false;
          // Re-trigger shake animation on every submit (remove + reflow + re-add)
          errorBanner.style.animation = 'none';
          errorBanner.offsetHeight; // force reflow
          errorBanner.style.animation = '';
          // Scroll to the banner so user definitely sees it
          errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Focus first invalid field after scroll settles
        const firstField = form.querySelector('[name="' + errors[0].field + '"]');
        if (firstField) {
          setTimeout(function () { try { firstField.focus({ preventScroll: true }); } catch (e) {} }, 600);
        }

        showToast('⚠ Faltan ' + errors.length + ' campo' + (errors.length > 1 ? 's' : ''));
        return;
      }

      let totals = recalc();
      let paymentRadio = totals.paymentRadio;
      let paymentValue = paymentRadio ? paymentRadio.value : 'cod';

      // Fase 2 (FLOW-03) — camino rápido contra-entrega cuando el envío es GRATIS.
      // Decisión A1 (LOCKED): el pedido rápido se crea con paymentMethod='cod' a
      // PRECIO LLENO (sin el 15% de SINPE). Q3: la zona de coordinación (>60km,
      // data-ship-state='coord') NO dispara el camino rápido. El estado de envío
      // se lee del chip DOM (canal entre archivos pintado por prem-eta-init.js),
      // siempre con getAttribute (XSS-safe, T-02-20) — nunca innerHTML.
      var chipEl = form.querySelector('[data-ship-chip]');
      var shipState = chipEl ? chipEl.getAttribute('data-ship-state') : '';
      // shippingPrice===0 excluye envío de pago; shipState!=='coord' excluye coordinación.
      var isFreeShip = (totals.shippingPrice === 0) && (shipState !== 'coord');
      if (isFreeShip) {
        // El DOM trae SINPE checked en free-ship (updatePaymentForShipping deja
        // sinpe por leftover de Fase 1). recalcTotals() deriva el descuento del
        // radio :checked, así que para que totals.discount===0 (precio lleno) hay
        // que MARCAR el radio COD antes de recalcular, no solo reasignar la var.
        var codRadio = form.querySelector('input[name="payment"][value="cod"]');
        if (codRadio) {
          // Un radio `disabled checked` sigue matcheando :checked para
          // getSelectedRadio — NO des-deshabilitar el DOM ni tocar
          // updatePaymentForShipping; solo marcar y re-derivar los totales.
          codRadio.checked = true;
          totals = recalc();
          paymentRadio = totals.paymentRadio;
          paymentValue = paymentRadio ? paymentRadio.value : 'cod';
        } else {
          // Defensa: si no existe el radio COD en el DOM, fijar paymentValue='cod'
          // directo. v41CartDiscount queda null igual (su guard exige
          // paymentValue==='sinpe'); el discount residual solo es posible en este
          // fallback improbable.
          paymentValue = 'cod';
        }
      }

      // Email es OPCIONAL (spec 2026-05-22) pero el worker exige customer.email.
      // Si el cliente no lo da, sintetizamos uno desde el teléfono para que el
      // pedido se cree igual. El contacto real es el WhatsApp/teléfono.
      const phoneForEmail = (data.phone || '').replace(/\D/g, '');
      const orderEmail = data.email || ('cli' + (phoneForEmail || Date.now()) + '@pedidos.innovazone.shop');

      /* Costa Rica province name → Shopify ISO subdivision code */
      const CR_PROVINCE_CODES = {
        'San José': 'SJ',
        'San Jose': 'SJ',
        'Alajuela': 'A',
        'Cartago': 'C',
        'Heredia': 'H',
        'Guanacaste': 'G',
        'Puntarenas': 'P',
        'Limón': 'L',
        'Limon': 'L'
      };

      function pickDiscountCode(bulkTier, paymentValue) {
        // V42 (Kevin 2026-06-12) — los códigos *-SINPE quedan RETIRADOS: el 15%
        // por SINPE web ya no existe (vive solo en el flujo prepago WhatsApp).
        // Solo sobreviven los códigos de volumen. paymentValue se ignora.
        const wholesale = bulkTier === 'wholesale';
        const twoPack = bulkTier === 'two_pack';

        if (wholesale) return 'PREMIUM-WHOLESALE'; // optional
        if (twoPack)   return 'PREMIUM-2PACK';     // active
        return '';
      }

      function buildCheckoutUrl(d, discountCode) {
        const provinceCode = CR_PROVINCE_CODES[d.province] || '';
        const nameParts = (d.name || '').trim().split(/\s+/);
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';
        // Phone: strip spaces/dashes for Shopify validation
        const phoneClean = (d.phone || '').replace(/[^\d+]/g, '');

        const params = [];
        function add(k, v) {
          if (v != null && v !== '') params.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
        // Auto-apply discount code (V39) — falls through gracefully if code doesn't exist
        if (discountCode) add('discount', discountCode);
        // Contact
        add('checkout[email]', orderEmail);
        // Shipping address — Shopify accepts a comprehensive set of permalink params
        add('checkout[shipping_address][first_name]', firstName);
        add('checkout[shipping_address][last_name]', lastName);
        add('checkout[shipping_address][address1]', d.address);
        add('checkout[shipping_address][address2]', d.district);
        add('checkout[shipping_address][city]', d.canton);
        add('checkout[shipping_address][province]', provinceCode);
        add('checkout[shipping_address][country]', 'CR');
        add('checkout[shipping_address][phone]', phoneClean);
        // Costa Rica doesn't really use postal codes; Shopify accepts blanks
        // but some checkouts demand one — pass a province-default if available.
        add('checkout[shipping_address][zip]', '10101');
        // Billing = shipping (so customer doesn't fill it twice at checkout)
        add('checkout[billing_address][first_name]', firstName);
        add('checkout[billing_address][last_name]', lastName);
        add('checkout[billing_address][address1]', d.address);
        add('checkout[billing_address][address2]', d.district);
        add('checkout[billing_address][city]', d.canton);
        add('checkout[billing_address][province]', provinceCode);
        add('checkout[billing_address][country]', 'CR');
        add('checkout[billing_address][phone]', phoneClean);
        add('checkout[billing_address][zip]', '10101');
        return '/checkout?' + params.join('&');
      }

      // =====================================================================
      // UNIFIED CHECKOUT (V36) — ALL methods route through Shopify checkout.
      //   1. Items + customer data go into the Shopify cart
      //   2. WhatsApp opens in a new tab with the full order brief (so the
      //      merchant gets immediate notification and the customer can
      //      coordinate delivery instantly)
      //   3. The main window redirects to /checkout pre-filled
      //
      //   At /checkout the customer picks payment method:
      //     • SINPE Móvil      → Manual Payment Method "SINPE" (must be enabled
      //                          in Admin → Settings → Payments → Manual)
      //     • Contra entrega   → Manual Payment Method "COD" (same panel)
      //     • Tarjeta cuotas 0% → Tilopay gateway (already configured)
      //
      //   The order then lives in Shopify Admin → Orders. From there
      //   Shopify Flow can forward it to Kommo CRM (see docs).
      // =====================================================================
      const cuotas = paymentValue === 'card' ? (parseInt(data.installments, 10) || 1) : null;
      const units = totals.bulk.units;

      const paymentLabel =
        paymentValue === 'sinpe' ? 'SINPE Móvil' :
        paymentValue === 'cod'   ? 'Pago contra entrega' :
        paymentValue === 'card'  ? ('Tarjeta — ' + cuotas + ' cuota(s) 0%') :
                                   'Pago a coordinar';

      setSubmitLoading(true,
        paymentValue === 'card' ? 'ABRIENDO PAGO…' : 'CREANDO PEDIDO…');

      const giftRadioU = getSelectedRadio('gift');
      const giftLabelU = giftRadioU ? (giftRadioU.dataset.giftLabel || giftRadioU.value) : null;

      // Line item properties — visible inside the order in Shopify Admin
      const properties = {
        'Nombre': data.name,
        'Teléfono': data.phone,
        'Correo': data.email,
        'Provincia': data.province,
        'Cantón': data.canton,
        'Distrito': data.district,
        'Dirección': data.address,
        'Tier': totals.bulk.label,
        'Envío preferido': totals.shippingRadio ? totals.shippingRadio.dataset.label : '—',
        'Garantía extra': totals.warrantyRadio ? totals.warrantyRadio.dataset.label : 'Estándar',
        'Método de pago': paymentLabel
      };
      if (paymentValue === 'card') properties['Cuotas'] = cuotas + ' cuota(s) 0%';
      if (data.cedula) properties['Cédula'] = data.cedula;
      if (data.geo_lat && data.geo_lng) {
        properties['GPS'] = data.geo_lat + ',' + data.geo_lng;
        properties['Maps'] = 'https://maps.google.com/?q=' + data.geo_lat + ',' + data.geo_lng;
      } else {
        var addrQueryProp = [data.address, data.district, data.canton, data.province, 'Costa Rica']
          .filter(function (p) { return p && String(p).trim(); })
          .join(', ');
        properties['Maps'] = 'https://maps.google.com/?q=' + encodeURIComponent(addrQueryProp);
      }
      if (giftLabelU && giftLabelU !== 'Sin regalo' && giftLabelU !== '') {
        properties['Regalo gratis'] = giftLabelU;
      }

      const cartItems = [{
        id: parseInt(variantId.split('/').pop(), 10) || variantId,
        quantity: units,
        properties: properties
      }];

      // Cross-sell items (combos) — separate lines so each is visible
      if (totals.xsellList && totals.xsellList.length > 0) {
        totals.xsellList.forEach(function (x) {
          if (x.variantId) {
            const vid = x.variantId.toString().replace('gid://shopify/ProductVariant/', '');
            cartItems.push({
              id: parseInt(vid, 10) || vid,
              quantity: 1,
              properties: { '_combo_con': productTitle }
            });
          }
        });
      }

      // V39 — Compute price components so merchant sees the exact gap
      // between Shopify line-item total and the quote shown on the PDP.
      const fmt2 = function(n){ return '₡' + Math.round(n).toLocaleString('es-CR'); };
      const subtotalShopify = totals.productsSubtotal || 0;
      const bulkSavings = totals.bulkSavings || 0;            // descuento vs precio base × qty
      const warrantyAdd = totals.warrantyPrice || 0;          // monto a sumar
      const shippingAdd = totals.shippingPrice || 0;          // monto a sumar
      const sinpeDiscount = totals.discount || 0;              // descuento por SINPE
      const expectedTotal = totals.total || 0;                // total que vio el cliente en el PDP

      // Cart-level attributes (order-wide context). Each component on its own
      // line so the merchant can adjust the order in Admin to match the quote.
      const cartAttrs = {
        attributes: {
          '01_Tier': totals.bulk.label,
          '02_Descuento_bulk': bulkSavings > 0 ? '-' + fmt2(bulkSavings) : '—',
          '03_Garantia_elegida': totals.warrantyRadio ? totals.warrantyRadio.dataset.label : 'Estándar',
          '04_Garantia_costo_extra': warrantyAdd > 0 ? '+' + fmt2(warrantyAdd) : '—',
          '05_Envio_elegido': totals.shippingRadio ? totals.shippingRadio.dataset.label : '—',
          '06_Envio_costo_extra': shippingAdd > 0 ? '+' + fmt2(shippingAdd) : '—',
          '07_Metodo_pago': paymentLabel,
          '08_Descuento_SINPE': sinpeDiscount > 0 ? '-' + fmt2(sinpeDiscount) : '—',
          '09_TOTAL_acordado_PDP': fmt2(expectedTotal),
          '10_ADVERTENCIA': 'Shopify cobra variant×qty. Ajustar la orden manualmente para que coincida con 09_TOTAL_acordado_PDP.',
          'Provincia': data.province,
          'Cantón': data.canton,
          'Distrito': data.district,
          'Dirección exacta': data.address,
          'GPS lat': data.geo_lat || '',
          'GPS lng': data.geo_lng || '',
          'GPS Maps URL': (data.geo_lat && data.geo_lng)
            ? 'https://maps.google.com/?q=' + data.geo_lat + ',' + data.geo_lng
            : '',
          'Origen': 'innovazone.shop · PDP multi-step'
        },
        note:
          '⚠ AJUSTE MANUAL REQUERIDO ⚠\n' +
          '— Tier: ' + totals.bulk.label + '\n' +
          (bulkSavings > 0 ? '— Descuento bulk acordado: -' + fmt2(bulkSavings) + '\n' : '') +
          (warrantyAdd > 0 ? '— Garantía extendida: +' + fmt2(warrantyAdd) + '\n' : '') +
          (shippingAdd > 0 ? '— Envío upgrade: +' + fmt2(shippingAdd) + '\n' : '') +
          (sinpeDiscount > 0 ? '— Descuento SINPE 15%: -' + fmt2(sinpeDiscount) + '\n' : '') +
          '— TOTAL ACORDADO con cliente: ' + fmt2(expectedTotal) + '\n' +
          '— Pago: ' + paymentLabel + '\n' +
          '\nLa caja de Shopify cobra variant.price × qty. ' +
          'Ajustá la orden con un Adjustment line item o aplica un descuento ' +
          'para que el total coincida con el TOTAL ACORDADO.'
      };

      // V39 — pick a discount code based on tier+payment so the Shopify
      // checkout total at least partially matches the PDP quote
      const discountCode = pickDiscountCode(totals.bulk.tier, paymentValue);
      const checkoutUrl = buildCheckoutUrl(data, discountCode);

      // Payment-specific WhatsApp note
      let paymentSpecific = '';
      if (paymentValue === 'sinpe') {
        paymentSpecific = '\n⚠ *Cliente eligió SINPE Móvil.* Mandale el número SINPE y pedile el *comprobante de pago* (captura). Despachamos al recibir comprobante.';
      } else if (paymentValue === 'cod') {
        paymentSpecific = '\n💵 *Pago contra entrega.* Coordinar día/hora con cliente. Pagás al mensajero (efectivo o SINPE móvil al recibir).';
      } else if (paymentValue === 'card') {
        paymentSpecific = '\n💳 *Cliente fue a checkout con tarjeta (' + cuotas + ' cuota(s) 0%).* Si no completa el pago, contactalo para seguimiento.';
      }
      const waMsg = buildOrderLines(totals, data, paymentSpecific);
      const waUrl = 'https://wa.me/' + waPhone + '?text=' + encodeURIComponent(waMsg);

      // ===================================================================
      // V41 PATH — If a Vercel function URL is configured, send the order
      // there. The function creates a Shopify Draft Order with EXACT pricing
      // (bulk discount as line-item discount, warranty as custom line item,
      // shipping as shipping line, SINPE as cart discount). On success we
      // redirect customer to invoiceUrl for Tarjeta (Tilopay), or open
      // WhatsApp with the order # for SINPE/COD. If the function fails for
      // any reason, we transparently fall back to the V36 cart+checkout flow.
      // ===================================================================
      function toVariantGid(idOrGid) {
        if (idOrGid == null) return null;
        var s = String(idOrGid);
        if (s.indexOf('gid://') === 0) return s;
        var n = s.replace(/\D/g, '');
        return n ? 'gid://shopify/ProductVariant/' + n : null;
      }

      function runShopifyCartFallback() {
        // V36 unified-checkout flow: cart + redirect to Shopify checkout.
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart_add_failed');
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(cartAttrs)
          });
        }).then(function () {
          showToast('✓ Te llevamos al checkout…');
          window.location.href = checkoutUrl;
        });
      }

      var v41Promise;
      if (orderApiUrl) {
        // Build the payload the Vercel function expects
        var v41Customer = {
          email: orderEmail,
          phone: (data.phone || '').replace(/[^\d+]/g, ''),
          firstName: (data.name || '').trim().split(/\s+/)[0] || '',
          lastName: (data.name || '').trim().split(/\s+/).slice(1).join(' ') || '',
          address1: data.address,
          address2: data.district,
          city: data.canton,
          province: CR_PROVINCE_CODES[data.province] || '',
          zip: '10101'
        };
        // V42 — unitPrice per line is REQUIRED for orderCreate path (SINPE/COD).
        // For draftOrderCreate (Tarjeta) we still use discountAmount.
        // unitPrice for main line = productsSubtotal / units (covers bulk pricing)
        var v41MainUnitPrice = units > 0 ? Math.round((totals.productsSubtotal || basePrice * units) / units) : basePrice;
        var v41LineItems = [{
          variantId: toVariantGid(variantId),
          quantity: units,
          discountAmount: totals.bulkSavings || 0,
          discountTitle: totals.bulkSavings > 0 ? ('Descuento ' + totals.bulk.label) : null,
          unitPrice: v41MainUnitPrice
        }];
        // V41.9 — incluir discountAmount = original - cross_sell_price para que el
        // Worker aplique appliedDiscount al line item y el draft cobre el precio correcto.
        // V42 — unitPrice = x.price (precio cross-sell ya descontado) para orderCreate.
        var v41CrossSell = (totals.xsellList || []).map(function (x) {
          var disc = Math.max(0, (x.originalPrice || x.price) - x.price);
          return {
            variantId: toVariantGid(x.variantId),
            quantity: 1,
            discountAmount: disc,
            discountTitle: disc > 0 ? 'Combo InnovaZone' : null,
            unitPrice: x.price
          };
        }).filter(function (x) { return x.variantId; });
        var v41Warranty = warrantyAdd > 0 ? {
          title: 'Garantía Extendida — ' + (totals.warrantyRadio ? totals.warrantyRadio.dataset.label : 'extendida') + (units > 1 ? ' × ' + units : ''),
          price: warrantyAdd
        } : null;
        var v41Shipping = {
          title: totals.shippingRadio ? totals.shippingRadio.dataset.label : 'Envío',
          price: shippingAdd || 0
        };
        // V41.9 — SINPE va como FIXED para que cubra subtotal+envío (Shopify PERCENTAGE
        // solo aplica a line items, no a shipping → gap de ~15% del envío).
        // sinpeDiscount ya fue calculado en computeTotals como round(subtotal × 15%)
        // donde subtotal incluye productos + warranty + envío + cross-sell.
        var v41CartDiscount = (sinpeDiscount > 0 && paymentValue === 'sinpe') ? {
          type: 'fixed',
          value: sinpeDiscount,
          title: 'Descuento SINPE Móvil 15%'
        } : null;
        var v41CustomAttrs = Object.keys(cartAttrs.attributes).map(function (k) {
          return { key: k, value: String(cartAttrs.attributes[k] || '') };
        });
        var v41Payload = {
          customer: v41Customer,
          lineItems: v41LineItems,
          crossSell: v41CrossSell,
          warranty: v41Warranty,
          shipping: v41Shipping,
          cartDiscount: v41CartDiscount,
          customAttributes: v41CustomAttrs,
          paymentMethod: paymentValue,
          bulkTier: totals.bulk.tier,
          note: cartAttrs.note,
          // Send the invoice email only for Tarjeta (so customer gets the
          // Tilopay payment link) Y solo si hay correo REAL (el sintético no
          // entrega). Sin correo real, igual redirigimos a invoiceUrl.
          sendInvoice: paymentValue === 'card' && !!data.email
        };

        v41Promise = fetch(orderApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(v41Payload)
        }).then(function (r) {
          return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; });
        }).then(function (result) {
          if (!result.ok || !result.body || !result.body.ok) {
            // Debug en consola (window.__v41Debug); SIN overlay al cliente.
            if (window.__showV41Debug) window.__showV41Debug(result);
            throw new Error('v41_failed');
          }
          var orderName = result.body.orderName || '';
          var invoiceUrl = result.body.invoiceUrl;
          showToast('✓ Pedido ' + orderName + ' creado');

          if (paymentValue === 'card' && invoiceUrl) {
            // Tarjeta — go to Shopify-hosted invoice page (Tilopay processes)
            window.location.href = invoiceUrl;
            return;
          }
          // SINPE / COD — open WhatsApp with order number + payment instructions
          var enrichedMsg = '✅ *Pedido ' + orderName + ' creado en Shopify Admin*\n\n' + waMsg;
          var enrichedUrl = 'https://wa.me/' + waPhone + '?text=' + encodeURIComponent(enrichedMsg);
          try { window.open(enrichedUrl, '_blank', 'noopener'); } catch (e) {}
          // Phase 3 (B2): en vez de RECARGAR, revelar el modal post-pedido sin
          // recargar (form vivo). showPostOrderScreen reubica las palancas y
          // reusa recalc(); el redirect /?order= queda SOLO como fallback dentro
          // de showPostOrderScreen para productos sin el markup #prem-post-order.
          // La orden ya está creada (un solo POST al Worker); los extras se avisan
          // por WhatsApp + lead Kommo manual (B1, POST-04). Capturamos los datos
          // del comprador en el closure para reabrir WhatsApp con extras (Task 2).
          postBuyerData = data;
          postPaymentSpecific = paymentSpecific;
          showPostOrderScreen(orderName);
        });
      } else {
        // No Vercel URL configured — go straight to the V36 fallback
        v41Promise = Promise.reject(new Error('no_order_api_url_configured'));
      }

      v41Promise.catch(function (err) {
        // Worker no disponible / rechazó → caer al checkout estándar (V36) en
        // silencio. Sin overlay ni toast alarmante: el cliente sigue al checkout.
        if (orderApiUrl) {
          console.warn('[premium-form] V41 unavailable, falling back to V36', err);
        }
        return runShopifyCartFallback();
      }).catch(function (err) {
        // V41 y V36 fallaron — último recurso: abrir WhatsApp para coordinar.
        console.error('[premium-form] both flows failed', err);
        setSubmitLoading(false);
        try { window.open(waUrl, '_blank', 'noopener'); } catch (e) {}
        alert('Hubo un problema sincronizando con Shopify. Te abrimos WhatsApp para coordinar manualmente.');
      });
    });
  }

  /* ------------------------------------------------------------------------
     3b. FIRST-TAP FIX (iz-cta-libre) — mobile keyboard swallows the first tap
     on the submit button: closing the keyboard consumes that touch and no
     click ever fires. touchend submits directly when the keyboard was open,
     guarded so a scroll or a second finger never fires an order by accident.
  ------------------------------------------------------------------------ */
  (function () {
    if (!submitBtn || !form) return;
    var armed = false;
    var startX = 0, startY = 0;
    var lastTouchSubmitAt = 0;

    submitBtn.addEventListener('touchstart', function (e) {
      armed = false;
      if (e.touches.length !== 1) return;
      var active = document.activeElement;
      var keyboardOpen = active && ['INPUT', 'SELECT', 'TEXTAREA'].indexOf(active.tagName) !== -1;
      if (!keyboardOpen) return;
      armed = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    submitBtn.addEventListener('touchend', function (e) {
      if (!armed) return;
      armed = false;
      if (submitBtn.disabled) return;
      if (e.changedTouches.length !== 1) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.sqrt(dx * dx + dy * dy) > 12) return;
      e.preventDefault();
      lastTouchSubmitAt = Date.now();
      submitBtn.dataset.izCtaLibre = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submitBtn);
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }, { passive: false });

    submitBtn.addEventListener('click', function (e) {
      if (Date.now() - lastTouchSubmitAt < 1000) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  })();

})();

/* ============================================================================
   MULTI-STEP FLOW (V34) — one question per screen
   Wraps the existing purchase form into a step-by-step micro-commitment UX.
   Validation uses HTML5 checkValidity() and reuses [data-error-for] slots.
============================================================================ */
(function initFlow() {
  var flow = document.querySelector('[data-flow-current]');
  if (!flow) return;

  var steps = Array.prototype.slice.call(flow.querySelectorAll('[data-step]'));
  var total = parseInt(flow.getAttribute('data-flow-total'), 10) || steps.length;
  var fill = flow.querySelector('[data-flow-progress-fill]');
  var stepNumEl = flow.querySelector('[data-flow-step-num]');
  var stepTitleEl = flow.querySelector('[data-flow-step-title]');

  // ── SINGLE-VIEW MODE (Phase 1, Plan 03) ───────────────────────────────────
  // The capture collapsed from 5 gated steps to ONE always-visible scrollable
  // view (data-flow-total="1"). The legacy showStep()/hidden gating must NOT
  // re-hide the capture on load — every capture region (tiers/location/phone)
  // is server-rendered `is-active` and must stay visible WITHOUT JS (Brave
  // no-JS-hidden rule). We early-return before boot so showStep(1) never runs
  // and never sets `hidden` on steps 2/3. The error-clear `input` listener is
  // re-bound below so inline validation feedback still works in single view.
  // The deferred warranty/payment block (data-step="4") keeps its server
  // `hidden` attribute untouched (Phase 3 relocates it post-pedido).
  var singleView = (total <= 1) ||
    (flow.querySelectorAll('[data-step]:not([hidden])').length <= 1) ||
    (flow.querySelectorAll('[data-flow-next], [data-flow-back]').length === 0);

  if (singleView) {
    // Clear inline validation errors as the user types (single-view safe).
    flow.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp || !inp.name) return;
      var fld = inp.closest('.prem-field');
      if (fld) fld.classList.remove('is-invalid');
      var errEl = flow.querySelector('[data-error-for="' + inp.name + '"]');
      if (errEl) {
        errEl.textContent = '';
        errEl.classList.remove('is-visible');
      }
    });
    return; // never re-hide the single-view capture
  }

  function showStep(n) {
    if (n < 1) n = 1;
    if (n > total) n = total;
    var newTitle = '';
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      var sn = parseInt(s.getAttribute('data-step'), 10);
      var isActive = sn === n;
      s.hidden = !isActive;
      if (isActive) {
        newTitle = s.getAttribute('data-step-title') || '';
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    }
    flow.setAttribute('data-flow-current', String(n));
    var pct = Math.round((n / total) * 100);
    if (fill) fill.style.width = pct + '%';
    if (stepNumEl) stepNumEl.textContent = 'Paso ' + n + ' de ' + total;
    if (stepTitleEl) stepTitleEl.textContent = newTitle;

    // Scroll the flow into view if its top is above the viewport. We use
    // window scroll rather than scrollIntoView so the header stays in view.
    try {
      var rect = flow.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
        window.scrollTo({
          top: window.pageYOffset + rect.top - 90,
          behavior: 'smooth'
        });
      }
    } catch (_) { /* older browsers */ }
  }

  // Spanish messages for HTML5 default validation errors (V40)
  // The browser renders validationMessage in user locale. We override.
  function spanishValidationMessage(input) {
    var v = input.validity;
    if (v.valueMissing) {
      if (input.type === 'checkbox' || input.type === 'radio') return 'Por favor seleccioná una opción.';
      if (input.tagName === 'SELECT') return 'Por favor seleccioná una opción.';
      return 'Este campo es obligatorio.';
    }
    if (v.typeMismatch) {
      if (input.type === 'email') return 'Escribí un correo válido (ej: nombre@gmail.com).';
      if (input.type === 'url') return 'Escribí una dirección web válida.';
      return 'El formato no es correcto.';
    }
    if (v.patternMismatch) {
      if (input.name === 'phone') return 'Solo se aceptan números, espacios y guiones.';
      if (input.name === 'cedula') return 'Solo se aceptan números y guiones.';
      return 'El formato no es correcto.';
    }
    if (v.tooShort) return 'Demasiado corto. Mínimo ' + input.minLength + ' caracteres.';
    if (v.tooLong) return 'Demasiado largo. Máximo ' + input.maxLength + ' caracteres.';
    if (v.rangeUnderflow) return 'Valor demasiado bajo. Mínimo ' + input.min + '.';
    if (v.rangeOverflow) return 'Valor demasiado alto. Máximo ' + input.max + '.';
    if (v.stepMismatch) return 'Valor no permitido.';
    if (v.badInput) return 'El valor ingresado no es válido.';
    return 'Por favor revisá este campo.';
  }

  // Custom per-step validators that catch issues HTML5 alone misses
  function customValidate(name, value) {
    if (name === 'phone') {
      var digits = (value || '').replace(/[^\d]/g, '');
      // Costa Rica phones are 8 digits. Country-code 506 prefix is optional;
      // 11 digits total when included. Anything else is an error.
      if (digits.length === 11 && digits.indexOf('506') === 0) return null;
      if (digits.length !== 8) {
        return 'El teléfono debe tener 8 dígitos (Costa Rica). Probá sin el 506.';
      }
      return null;
    }
    if (name === 'email') {
      if (!/^\S+@\S+\.\S+$/.test(value || '')) {
        return 'Escribí un correo válido (ej: nombre@gmail.com).';
      }
      return null;
    }
    if (name === 'cedula') {
      var d = (value || '').replace(/[^\d]/g, '');
      if (d.length < 9 || d.length > 12) {
        return 'La cédula debe tener entre 9 y 12 dígitos.';
      }
      return null;
    }
    if (name === 'address') {
      if ((value || '').trim().length < 8) {
        return 'Escribí la dirección con puntos de referencia (mínimo 8 caracteres).';
      }
      return null;
    }
    return null;
  }

  function markError(step, inp, msg) {
    var errorEl = step.querySelector('[data-error-for="' + inp.name + '"]');
    if (errorEl) {
      errorEl.textContent = msg || '';
      // .prem-field__error has display:none by default; needs is-visible
      // to actually show the message text.
      errorEl.classList.toggle('is-visible', !!msg);
    }
    var field = inp.closest('.prem-field');
    if (field) field.classList.toggle('is-invalid', !!msg);
  }

  function validateStep(n) {
    var step = flow.querySelector('[data-step="' + n + '"]');
    if (!step) return true;
    var required = step.querySelectorAll('input[required], select[required], textarea[required]');
    var allValid = true;
    var firstInvalid = null;
    for (var i = 0; i < required.length; i++) {
      var inp = required[i];
      // Skip inputs hidden by an ancestor (e.g. conditional cedula block)
      if (inp.offsetParent === null && inp.type !== 'hidden') continue;

      var ok = inp.checkValidity();
      var customMsg = ok ? customValidate(inp.name, inp.value) : null;
      // V40 — Spanish translations beat the browser's locale-dependent default
      var msg = !ok ? spanishValidationMessage(inp) : customMsg;
      markError(step, inp, msg);

      if (msg) {
        allValid = false;
        if (!firstInvalid) firstInvalid = inp;
      }
    }
    if (!allValid && firstInvalid) {
      try { firstInvalid.focus({ preventScroll: false }); } catch (_) { firstInvalid.focus(); }
      // Toast so user sees something happened even if focus jumps offscreen
      try {
        var ev = new CustomEvent('prem-flow-error', { detail: { step: n } });
        document.dispatchEvent(ev);
      } catch (_) {}
    }
    return allValid;
  }

  function getCurrent() {
    return parseInt(flow.getAttribute('data-flow-current'), 10) || 1;
  }

  flow.addEventListener('click', function (e) {
    var nextBtn = e.target.closest('[data-flow-next]');
    if (nextBtn) {
      e.preventDefault();
      var cur = getCurrent();
      if (validateStep(cur)) showStep(cur + 1);
      return;
    }
    var backBtn = e.target.closest('[data-flow-back]');
    if (backBtn) {
      e.preventDefault();
      showStep(getCurrent() - 1);
    }
  });

  // Clear inline validation errors as the user types
  flow.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.name) return;
    var field = inp.closest('.prem-field');
    if (field) field.classList.remove('is-invalid');
    var errorEl = flow.querySelector('[data-error-for="' + inp.name + '"]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
  });

  // Enter on a non-submit input advances to next step (keyboard friendly)
  flow.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || t.tagName === 'TEXTAREA' || t.type === 'submit') return;
    var cur = getCurrent();
    if (cur < total) {
      e.preventDefault();
      if (validateStep(cur)) showStep(cur + 1);
    }
  });

  // Boot — guarantee only step 1 is visible
  showStep(1);
})();

/* ============================================================================
   GPS LOCATION BUTTON (V35)
   Captures lat/lng via browser geolocation. Coordinates go into hidden inputs
   that the WhatsApp message handler picks up to build a Google Maps link.
============================================================================ */
(function initGeo() {
  var geoBlock = document.querySelector('[data-geo-block]');
  if (!geoBlock) return;
  var btn = geoBlock.querySelector('[data-geo-btn]');
  var label = geoBlock.querySelector('[data-geo-label]');
  var hint = geoBlock.querySelector('[data-geo-hint]');
  var latInput = geoBlock.querySelector('[data-geo-lat]');
  var lngInput = geoBlock.querySelector('[data-geo-lng]');
  var accInput = geoBlock.querySelector('[data-geo-acc]');
  var preview = geoBlock.querySelector('[data-geo-preview]');
  if (!btn) return;

  if (!('geolocation' in navigator)) {
    btn.disabled = true;
    if (hint) hint.textContent = 'Tu navegador no soporta GPS — completá la dirección manualmente.';
    return;
  }

  // Nota: el autollenado de distrito por GPS lo hace prem-eta-init.js al escuchar el
  // evento 'prem:geo' (nearestZona → input[name="district"] + ETA). Aquí solo se captura
  // el pin y se dispara ese evento; NO se duplica la lógica de geocoding.

  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    btn.disabled = true;
    if (label) label.textContent = '📍 Buscando tu ubicación…';
    geoBlock.classList.remove('is-success', 'is-error');

    navigator.geolocation.getCurrentPosition(
      function onOK(pos) {
        var lat = pos.coords.latitude.toFixed(6);
        var lng = pos.coords.longitude.toFixed(6);
        var acc = pos.coords.accuracy ? Math.round(pos.coords.accuracy) : '';
        if (latInput) latInput.value = lat;
        if (lngInput) lngInput.value = lng;
        if (accInput) accInput.value = String(acc);
        // Avisar al motor ETA (prem-eta-init.js): autollena el distrito por zona más
        // cercana + muestra "cuándo le llega". El pin GPS ya se guardó arriba.
        document.dispatchEvent(new CustomEvent('prem:geo', { detail: { lat: lat, lng: lng } }));
        geoBlock.classList.add('is-success');
        if (label) label.textContent = '✓ Ubicación capturada' + (acc ? ' (±' + acc + ' m)' : '');
        if (hint) hint.textContent = 'El mensajero recibirá el pin exacto en el WhatsApp.';
        if (preview) {
          preview.href = 'https://maps.google.com/?q=' + lat + ',' + lng;
          preview.hidden = false;
        }
        btn.disabled = false;
      },
      function onErr(err) {
        geoBlock.classList.add('is-error');
        btn.disabled = false;
        if (label) label.textContent = '📍 Reintentar GPS';
        if (hint) {
          if (err && err.code === 1) {
            hint.textContent = 'Diste permiso denegado. Activá la ubicación en el navegador o completá la dirección manualmente.';
          } else if (err && err.code === 3) {
            hint.textContent = 'Tomó demasiado capturar la señal. Probá de nuevo cerca de una ventana.';
          } else {
            hint.textContent = 'No pudimos obtener tu ubicación. Probá de nuevo o completá la dirección manualmente.';
          }
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 30000
      }
    );
  });
})();



